import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser'; // Importação adicionada
import routes from './routes'
import { trackPageView, PAGE_TRACKED_ROUTES } from '../functions/insider'

export default function ({ store }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes: routes(store),

    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  // Insider Web SDK — somente para o cliente Coral (ins.js só é carregado no
  // template da academiacoral). Guard GLOBAL: dispara em toda troca de rota,
  // inclusive ao navegar entre páginas filhas do mesmo layout (o beforeEnter
  // do layout-pai não re-executa nesses casos). Re-empilha user/currency/page/init.
  if (process.env.PROJECT_FOLDER === 'academiacoral') {
    Router.afterEach((to, from, failure) => {
      // afterEach dispara em TODA navegação, inclusive abortadas/redirecionadas
      // (failure != null). Empilhar nelas geraria MAIS DE UM type:'init' na mesma
      // page load (ex.: redirect pós-login para home_route, hop '/' → '/home'),
      // e o validador do Insider exige exatamente UM init por página.
      if (failure) return;
      // Home, listagens e leituras de Treinamentos/Trilhas empilham no load da
      // PRÓPRIA página (mounted/watch) — pular aqui para não duplicar o init.
      if (PAGE_TRACKED_ROUTES.includes(to.name)) return;
      trackPageView(store, to)
    })
  }

  App.addListener('appUrlOpen', async function (event) {
    if (event.url.includes('/media_public/qrcode/')) {
      await Browser.open({ url: event.url });
      return;
    }

    const slug = event.url.split('.app').pop();

    if (slug) {
      Router.push({
        path: slug,
      });
    }
  });

  return Router
}